import React from 'react';
import type { Nullable } from 'corgi-types';

import Alert from '../../components/Alert';
import { MessageType } from '../../enums/Alert';

interface ReclamationAlertProps {
  message?: Nullable<string>;
  type?: MessageType;
}

const ReclamationAlert = ({ message, type = MessageType.Error }: ReclamationAlertProps) =>
  message ? (
    <Alert my="sp_8" type={type}>
      {message}
    </Alert>
  ) : null;

export default ReclamationAlert;
